import React from 'react';

const e = React.createElement;


export function translateMarkdown(text) {
  var mapped_text = text.split('\n').map(function(item, key) {
    var new_item = "", first_nonspace = false;
    for (var i = 0; i < item.length; i++) {
      if(item.charAt(i) === " " && !first_nonspace) {
        new_item = new_item + String.fromCharCode(160); // this assures proper rendering of offset spaces.
      } else {
        first_nonspace = true;
        new_item = new_item + item.charAt(i);
      }
    }
    new_item = item;

    var found_md = false;
    var is_p = true;

    if(new_item.startsWith("#")) {
      found_md = true;
      var counted_occurrences = new_item.split("#").length - 1;
      if(counted_occurrences === 1) {
        is_p = false;
        new_item = e('h1', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      } else if(counted_occurrences === 2) {
        is_p = false;
        new_item = e('h2', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      } else if(counted_occurrences === 3) {
        is_p = false;
        new_item = e('h3', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      } else if(counted_occurrences === 4) {
        is_p = false;
        new_item = e('h4', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      } else if(counted_occurrences === 5) {
        is_p = false;
        new_item = e('h5', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      } else if(counted_occurrences === 6) {
        is_p = false;
        new_item = e('h6', {key:key}, new_item.slice(counted_occurrences + 1, new_item.length));
      }
    }

    if(!found_md) {
      var item_linked = [];
      var index = 0, crawl = true;
      while(crawl) {
        var snipp_start = new_item.indexOf("[", index);
        if(snipp_start < 0) {
          if(item_linked.length === 0) item_linked = new_item;
          if(item_linked.length > 0) found_md = true;
          crawl = false;
        } else {
          var snipp_start_end = new_item.indexOf("]", snipp_start); // check for ) after ], to allow () in link text
          var snipp_end = new_item.indexOf(")", snipp_start_end);
          if(snipp_start_end > -1 && snipp_end > -1) {
            index = snipp_end;
            var snipp = new_item.slice(snipp_start, snipp_end+1);
            var snipp_before = new_item.slice(0, snipp_start);
            var snipp_after = new_item.slice(snipp_end+1, new_item.length);

            if(snipp_before.length > 0) item_linked.push(snipp_before);
            var link_title = snipp.split("]")[0].replace("[", "");
            var link_href = snipp.split("]")[1].split(' "')[0].replace("(", "").replace(")", "");
            
            item_linked.push(e('a', {href:link_href, title:link_href, target:"_blank"}, link_title));
            if(snipp_after.length > 0) item_linked.push(snipp_after);
          } else {
            crawl = false;
          }
        }
      }
      new_item = item_linked;
    }

    if(new_item === "") new_item = e('br');

    if(is_p) {
      return e('p', {key:key}, new_item);
    } else {
      return new_item;
    }
  });
  return mapped_text;
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/markdown.js
// module id = 236
// module chunks = 0